
    import { computed, defineComponent } from 'vue'

    import { useSearchStore } from '@/app/stores/search'

    export default defineComponent({
        setup () {
            const searchStore = useSearchStore()

            const query = computed<string>({
                get () {
                    return searchStore.query
                },
                set (value) {
                    searchStore.query = value
                }
            })

            return {
                query
            }
        }
    })
